import { useRef, useEffect } from "react";

export default function CategoryFilter({ category, setCategory }) {

  const categories = [
    { key: "all", label: "All", icon: "🍽" },
    { key: "snacks", label: "Snacks", icon: "🥟" },
    { key: "sweets", label: "Sweets", icon: "🍰" },
    { key: "combo", label: "Combo", icon: "🍱" }
  ];

  const containerRef = useRef();

  // 🔥 AUTO SCROLL ACTIVE INTO CENTER
  useEffect(() => {
    const activeEl = containerRef.current?.querySelector(".active");
    if (activeEl) {
      activeEl.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest"
      });
    }
  }, [category]);

  return (
    <div className="categories-wrapper">

      <div className="categories center" ref={containerRef}>
        {categories.map(cat => (
          <button
            key={cat.key}
            className={`category-pill ${category === cat.key ? "active" : ""}`}
            onClick={() => setCategory(cat.key)}
          >
            <span className="cat-icon">{cat.icon}</span>
            <span className="cat-text">{cat.label}</span>
          </button>
        ))}
      </div>

    </div>
  );
}